import { configureStore } from "@reduxjs/toolkit";
import onBoardReducer from './onboardSlice';
import globalStateReducer from './globalStateSlice';
import { persistenceMiddleware } from './persistenceMiddleware';
import { loadStateFromStorage, mergeStateWithStorage } from '../utils/statePersistence';

// Get initial state from reducer
const initialState = {
    onboard: onBoardReducer(undefined, { type: '@@INIT' }),
    globalState: globalStateReducer(undefined, { type: '@@INIT' })
};

// Load saved state from localStorage
const savedState = loadStateFromStorage();

// Merge saved state with initial state
const preloadedState = savedState ? mergeStateWithStorage(initialState, savedState) : undefined;

if (preloadedState && savedState) {
    console.log("✅ Loaded saved state from localStorage:", {
        mobilisationManagement: {
            selectedItems: preloadedState.globalState?.pages?.mobilisationManagement?.selectedItems?.length || 0,
            searchText: preloadedState.globalState?.pages?.mobilisationManagement?.searchText,
            currentPage: preloadedState.globalState?.pages?.mobilisationManagement?.currentPage,
            sortValue: preloadedState.globalState?.pages?.mobilisationManagement?.sortValue
        }
    });
}

const store = configureStore({
    reducer:{
        onboard: onBoardReducer,
        globalState: globalStateReducer
    },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }).concat(persistenceMiddleware)
})
export default store;